import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // or './App.css' if you added Tailwind there


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
